import Box from "@material-ui/core/Box";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import makeStyles from "@material-ui/core/styles/makeStyles";
import React from "react";

const MockSearch = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Typography className={classes.searchText}>Search</Typography>
      <Box
        className={classes.boxStyle}
        sx={{ display: "flex", alignItems: "flex-end" }}
      >
        <TextField
          fullWidth
          placeholder={"location or supplier"}
          InputProps={{ disableUnderline: true }}
          className={classes.textfieldStyle}
          classes={{
            root: classes.textFieldRoot,
          }}
        />
        <i
          style={{
            color: "#94A3B8",
            fontSize: "18px",
            margin: "8px",
          }}
          className={"fa-solid fa-magnifying-glass"}
        />
      </Box>
    </div>
  );
};

export default MockSearch;

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: "6%",
    display: "flex",
    flexDirection: "column",
    paddingTop: "16px",
    paddingLeft: "16px",
  },
  boxStyle: {
    border: "1px solid #E2E8F0",
    margin: "8px 0px",
    backgroundColor: "#FFFFFF",
    marginRight: "8px",
    width: "100%",
  },
  textfieldStyle: {
    height: "36px",
  },
  searchText: {
    fontWeight: "600",
    fontSize: "16px",
  },
  textFieldRoot: {
    paddingTop: "2px",
    paddingLeft: "8px",
  },
}));
